import { PayloadAction } from '@reduxjs/toolkit'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { IForm } from 'core-components/classes/models/IForm'

import { mapRequestProcessesProgressFromCrud } from '../../services/mapping/mapRequestProcessesProgressFromCrud'
import { IOnboardingState, IRequestActionParams } from '../models'

export const getProcessesProgressPending = (
  state: IOnboardingState,
  action: PayloadAction<unknown, string, { arg: IRequestActionParams }>
) => {
  const { meta } = action

  state.processesProgressData.meta = meta
  state.processesProgressData.status = RequestStatus.PENDING
  state.processesProgressData.message = ''
}

export const getProcessesProgressRejected = (
  state: IOnboardingState,
  action: PayloadAction<unknown, string, { arg: IRequestActionParams }>
) => {
  const { meta } = action

  state.processesProgressData.meta = meta
  state.processesProgressData.status = RequestStatus.REJECTED
  state.processesProgressData.message = action.payload as string
}

export const getProcessesProgressFulfilled = (
  state: IOnboardingState,
  action: PayloadAction<IForm | null, string, { arg: IRequestActionParams }>
) => {
  const { meta, payload } = action

  state.processesProgressData.meta = meta
  state.processesProgressData.status = RequestStatus.FULFILLED
  state.processesProgressData.message = ''
  if (payload && payload.requestProcessesProgress) {
    state.processesProgressData.data = mapRequestProcessesProgressFromCrud(
      payload.requestProcessesProgress
    )
  }
}
